/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentApprovalDecisionRequest } from '../models/AgentApprovalDecisionRequest';
import type { AgentApprovalListResponse } from '../models/AgentApprovalListResponse';
import type { AgentApprovalRow } from '../models/AgentApprovalRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AgentApprovalsService {
    /**
     * List the caller's pending agent approvals
     * @param userSession
     * @returns AgentApprovalListResponse Successful Response
     * @throws ApiError
     */
    public static listMyPendingAgentApprovals(
        userSession?: (string | null),
    ): CancelablePromise<AgentApprovalListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/agent-approvals/me',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Approve or deny one of the caller's pending agent approvals
     * @param approvalId
     * @param requestBody
     * @param userSession
     * @returns AgentApprovalRow Successful Response
     * @throws ApiError
     */
    public static decideMyAgentApproval(
        approvalId: string,
        requestBody: AgentApprovalDecisionRequest,
        userSession?: (string | null),
    ): CancelablePromise<AgentApprovalRow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/agent-approvals/{approval_id}/decide',
            path: {
                'approval_id': approvalId,
            },
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `approval_id is not a valid UUID`,
                403: `call-details approval can only be approved on the device`,
                404: `approval not the caller's`,
                409: `approval already decided or expired`,
                422: `Validation Error`,
            },
        });
    }
}
